import {CUSTOM_FIELD_RESOURCES} from '@/components/query/custom-fields';
import FilterSet from '@/components/query/filter-set';
import _ from '@/common/helpers';
import FILTER_TYPES from '@/components/query/filter-types';
import FILTER_SOURCE_TYPES from '@/components/query/filter-source-type';
import store from '@/store';

/* eslint-disable quote-props */
export default new FilterSet({
    id: 'dashboard-segment-filter',
    store,
    filterSpec: {
        '/websiteId': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'websites',
                labelBuilder: ({id, name}) => `${_.truncate(id, {limit: 11, dots: true})}-${name}`,
                value: 'id',
            },
        },
        '/gatewayAccountId': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'gatewayAccounts',
                labelBuilder: ({id, gatewayName}) => `${_.truncate(id, {limit: 11, dots: true})}-${gatewayName}`,
                value: 'id',
            },
        },
        '/currency': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.currencies,
            },
        },
        '/method': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.definitions,
                path: 'Method/enum',
            },
        },
        '/gatewayName': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.definitions,
                path: 'GatewayName/enum',
            },
        },
        '/bin': {
            type: FILTER_TYPES.text,
            format: 'bin',
        },
        '/rebillNumber': {
            type: FILTER_TYPES.numeric,
        },
        '/retryNumber': {
            type: FILTER_TYPES.numeric,
        },
        '/billingCountry': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.countries,
            },
        },
        '/customerEmailDomain': {
            type: FILTER_TYPES.text,
        },
        '/firstInvoiced': {
            type: FILTER_TYPES.datetime,
        },
        '/firstPaid': {
            type: FILTER_TYPES.datetime,
        },
        '/gatewayResponseMessage': {
            type: FILTER_TYPES.text,
        },
        '/isProcessedOutside': {
            type: FILTER_TYPES.boolean,
            label: 'Paid Outside Rebilly',
        },
        '/lead': {
            type: FILTER_TYPES.datetime,
            label: 'Lead Date',
        },
        '/lifetimeRevenue/amount': {
            label: 'Lifetime Revenue Amount',
            type: FILTER_TYPES.numeric,
        },
        '/lifetimeRevenue/amountUsd': {
            label: 'Lifetime Revenue Amount (USD)',
            type: FILTER_TYPES.numeric,
        },
        '/lifetimeRevenue/currency': {
            type: FILTER_TYPES.select,
            label: 'Lifetime Revenue Currency',
            options: {
                source: FILTER_SOURCE_TYPES.currencies,
            },
        },
        '/organizationId': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'organizations',
                labelBuilder: ({id, name}) => `${_.truncate(id, {limit: 11, dots: true})}-${name}`,
                value: 'id',
            },
        },
        '/cardBrand': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.paymentCardBrands,
            },
        },
        '/issuer': {
            type: FILTER_TYPES.text,
        },
        '/planId': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'plans',
                labelBuilder: ({id, name}) => `${_.truncate(id, {limit: 11, dots: true})}-${name}`,
                value: 'id',
            },
        },
        '/redemptionCode': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'coupons-redemptions',
                labelBuilder: ({redemptionCode, id}) => `${_.truncate(redemptionCode, {limit: 11, dots: true})}-${id}`,
                value: 'redemptionCode',
            },
        },
        '/customer/customFields': {
            type: FILTER_TYPES.custom,
            options: {resourceType: CUSTOM_FIELD_RESOURCES.customers},
        },
        '/leadSource/source': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Source (recent)',
        },
        '/leadSource/medium': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Medium (recent)',
        },
        '/leadSource/campaign': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Campaign (recent)',
        },
        '/leadSource/content': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Content (recent)',
        },
        '/leadSource/term': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Term (recent)',
        },
        '/leadSource/affiliate': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Affiliate (recent)',
        },
        '/leadSource/subAffiliate': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Sub Affiliate (recent)',
        },
        '/leadSource/salesAgent': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Sales Agent (recent)',
        },
        '/leadSource/amount': {
            type: FILTER_TYPES.numeric,
            label: 'Lead Source Amount (recent)',
        },
        '/leadSource/currency': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.currencies,
            },
            label: 'Lead Source Currency (recent)',
        },
        '/leadSource/path': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Path (recent)',
        },
        '/leadSource/ipAddress': {
            type: FILTER_TYPES.text,
            label: 'Lead Source IP Address (recent)',
        },
        '/originalLeadSource/source': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Source (original)',
        },
        '/originalLeadSource/medium': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Medium (original)',
        },
        '/originalLeadSource/campaign': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Campaign (original)',
        },
        '/originalLeadSource/content': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Content (original)',
        },
        '/originalLeadSource/term': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Term (original)',
        },
        '/originalLeadSource/affiliate': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Affiliate (original)',
        },
        '/originalLeadSource/subAffiliate': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Sub Affiliate (original)',
        },
        '/originalLeadSource/salesAgent': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Sales Agent (original)',
        },
        '/originalLeadSource/amount': {
            type: FILTER_TYPES.numeric,
            label: 'Lead Source Amount (original)',
        },
        '/originalLeadSource/currency': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.currencies,
            },
            label: 'Lead Source Currency (original)',
        },
        '/originalLeadSource/path': {
            type: FILTER_TYPES.text,
            label: 'Lead Source Path (original)',
        },
        '/originalLeadSource/ipAddress': {
            type: FILTER_TYPES.text,
            label: 'Lead Source IP Address (original)',
        },
    },
});
